import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=1a1513bb&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/article.css?vue&type=style&index=0&id=1a1513bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1513bb",
  null
  
)

export default component.exports